import { useAppConfig } from "@/api/app-config/useAppConfig";

// NOTE: Returns true when SAML_SEAT_TIERS_ENABLED is set to "true" on the
// server. Reads from the public /app-config endpoint (the same mechanism other
// backend feature flags use to reach the frontend) so the "Seat tiers by group"
// SAML-tab section is hidden entirely when the global kill-switch is off. The
// server mirrors the same guard, so a direct API caller can neither persist nor
// read seat-tier config while the flag is off.
export const useSamlSeatTiersEnabled = (): boolean => {
  const { data } = useAppConfig();
  return data?.isSamlSeatTiersEnabled ?? false;
};
